import { apiClientV2 } from '@/services/rest-api/apiClient'
const baseURL = process.env.VUE_APP_REST_API_IDENTITY

export const getCustomReport = async () => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: '/custom-content?type=report',
    headers: {
      namespace: 'identity',
    },
  })

  return response?.data
}

export const getCustomReportById = async (id) => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: `/custom-content/${id}`,
    headers: {
      namespace: 'identity',
    },
  })

  return response?.data
}

export const getSummaryDigest = async (category) => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: '/custom-content',
    params: {
      type: 'summary',
      category: category,
    },
    headers: {
      namespace: 'identity',
    },
  })

  return response?.data
}
